import { PageInfo } from '../../../components/PageHeader'
import { InternationalTplPageSlug } from '../../../domain/types'

export interface InternationalTplPageConfig extends PageInfo {
  slug: InternationalTplPageSlug
}

export const getInternationalTplPages = (t: (key: string) => string): InternationalTplPageConfig[] => {
  return [
    {
      route: '/international-tpl-country',
      title: t('intTplPageCountry'),
      slug: 'international-tpl-which-country-to-drive',
    },
    {
      route: '/international-tpl-days',
      title: t('intTplPageDays'),
      slug: 'international-tpl-insurance-period',
    },
    {
      route: '/international-tpl-personal-info',
      title: t('intTplPagePersonalInfo'),
      slug: 'international-tpl-personal-info',
    },
    {
      route: '/international-tpl-car-info',
      title: t('intTplPageCarInfo'),
      slug: 'international-tpl-car-info',
    },
    {
      route: '/international-tpl-offer',
      title: t('intTplPageOffer'),
      slug: 'international-tpl-offer',
    },
    {
      route: '/international-tpl-check-info',
      title: t('intTplPageCheckInfo'),
      slug: 'international-tpl-check-info',
    },
    {
      route: '/international-tpl-payment',
      title: t('intTplPagePayment'),
      slug: 'international-tpl-check-info', // Payment page might use same slug or need separate one
    },
  ]
}
